/* Touch/trackpad scrolling stays native; mouse dragging and keyboard arrows add desktop access. */
document.querySelectorAll('[data-fv-savings-track]').forEach(function (track) {
    var startX = 0, startScroll = 0, active = false, dragged = false;
    track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        active = true;
        dragged = false;
    });
    track.addEventListener('pointermove', function (event) {
        if (!active) return;
        var distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 6) return;
        dragged = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
        track.scrollLeft = startScroll - distance;
    });
    function stop() { active = false; track.classList.remove('is-dragging'); }
    track.addEventListener('pointerup', stop);
    track.addEventListener('pointercancel', function () { dragged = false; stop(); });
    track.addEventListener('lostpointercapture', stop);
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    track.addEventListener('click', function (event) {
        if (dragged) { event.preventDefault(); event.stopPropagation(); dragged = false; }
    }, true);
    track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var cards = track.querySelectorAll('.fv-savings-card');
        var step = cards[1].offsetLeft - cards[0].offsetLeft;
        track.scrollBy({left: (event.key === 'ArrowRight' ? 1 : -1) * step, behavior: 'auto'});
    });
});
